import Vue from 'vue'

//获取cookie、
export function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return (arr[2]);
  else
    return '';
}

//设置cookie,增加到vue实例方便全局调用
export function setCookie (c_name, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
};

//删除cookie
export function delCookie (name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};

/**
 * 过滤HTML标签
 */
export function removeHTMLTag(str) {
  str = str.replace(/<\/?[^>]*>/g, ''); //去除HTML tag
  str = str.replace(/[ | ]*\n/g, '\n'); //去除行尾空白
  //str = str.replace(/\n[\s| | ]*\r/g,'\n'); //去除多余空行
  str = str.replace(/ /ig, '');//去掉
  return str;
}

export function formatMoney(x) {
  var f = parseFloat(x);
  if (isNaN(f)) {
    return;
  }
  f = Math.round(x * 100) / 100;
  return f;
}

//检查手机号是否合法 11位数字即可
export function isValidPhone(str) {
  // var myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1}))+\d{8})$/;
  var myreg = /^\d{11}$/;
  if (!myreg.test(str)) {
    return false;
  } else {
    return true;
  }
}

//检查姓名:6-20位数字字母下划线
export function isValidName(str) {
  var myreg = /^([\u4e00-\u9fa5]{1,50}|[a-zA-Z\ \s]{1,50})$/;
  if (!myreg.test(str)) {
    return false;
  } else {
    return true;
  }
}

//检查密码： 6-20位字符
export function isValidPassword(str) {
  // var myreg = /^([\u4e00-\u9fa5]{1,20}|[a-zA-Z\ \s]{1,20})$/;
  var myreg =  /^(.*?){6,20}$/;
  if (!myreg.test(str)) {
    return false;
  } else {
    return true;
  }
}

//检查登录姓名:6-20位数字字母下划线
export function isValidLoginName(str) {
// var myreg = /^([\u4e00-\u9fa5]{1,20}|[a-zA-Z\ \s]{1,20})$/;
  var myreg = /^\w{6,20}$/;
  if (!myreg.test(str)) {
    return false;
  } else {
    return true;
  }
}

/**
 *深拷贝
 */
export function deepClone (obj) {
  let _obj = JSON.stringify(obj)
  return JSON.parse(_obj)
}

/**
 * 清除登录信息
 */
export function clearLoginInfo () {
  Vue.cookie.delete('token')
}

/**
 * 针对对象数据进行排序propertyName 要排序的属性名，order 1为正序0为倒序
 */
export function compare(propertyName,order) {
  return function (object1, object2) {
    var value1 = object1[propertyName];
    var value2 = object2[propertyName];
    if(order==0){
      if (value2 < value1) {
        return -1;
      }
      else if (value2 > value1) {
        return 1;
      }
      else {
        return 0;
      }
    }if(order==1){
      if (value2 > value1) {
        return -1;
      }
      else if (value2 < value1) {
        return 1;
      }
      else {
        return 0;
      }
    }

  }
}

/**
 * 获取当前时间(年月日)
 */
export function getCurrentTime (time) {
  var now = time ? new Date(time) : new Date()
  var year = now.getFullYear()
  var month = now.getMonth() + 1
  var day = now.getDate()
  month = month < 10 ? '0' + month : month
  day = day < 10 ? '0' + day : day
  return year + '-' + month + '-' + day
}

/**
 * 比较时间大小
 */
export function compareDate(date1,date2){
  console.log(date1)
  console.log(date2)
  var oDate1 = new Date(date1);
  var oDate2 = new Date(date2);
  if(oDate1.getTime() > oDate2.getTime()){
    return true; //第一个大
  } else {
    return false; //第二个大
  }
}

/**
 * 判断是否是PC端
 */
export function IsPC() {
  let userAgentInfo = navigator.userAgent;
  let Agents = ["Android", "iPhone",
    "SymbianOS", "Windows Phone",
    "iPad", "iPod"];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag
}

export function Percentage(number1, number2) {
  return (Math.round(number1/(number2) * 1000) / 10.00 + "%");
}

export function numberLength(number) {
  return number.toString().length
}

export function discountCoupon(number1, number2) {
  return (Math.round((number1 /number2) * 10) / 10.00)
}

export function percentNum(number1, number2) {
  return (Math.round(number1 / (number2) * 1000) / 10.00);
}

export function getBirthdayFromIdCard (idCard) {
  let birthday = "";
  if(idCard != null && idCard !== ""){
    if(idCard.length === 15){
      birthday = "19"+idCard.substr(6,6);
    } else if(idCard.length === 18){
      birthday = idCard.substr(6,8);
    }

    birthday = birthday.replace(/(.{4})(.{2})/,"$1-$2-");
  }

  return birthday;
}



// WEBPACK FOOTER //
// ./src/util/util.js